import { app, background, mainContainer, viewportInstances } from './app';
import { ViewportInstance } from './classes/ViewportInstance';
import { updateHTMLColour } from './main';
import { colouriseFilter, menu } from './screens/default';
import { settings, findSettingByID, settingValue } from './settings';
import { interpColour } from "./utils/customMaths";

export type Palette = {
    optionID: number;
    back1: number;
    back2: number;
    // useAlt: boolean;
    // alt1: number;
    // alt2: number;
    text1: number;
    text2: number;
    bits: BitSet;
}

type BitDetail = {
    sprite: string | undefined;
    rotationSheet?: string | undefined;
    weight: number;
    colourMode: number;
    // normal?: string | undefined;
    scale?: number | undefined;
    variableScale? : number | undefined;
    realbit?: boolean | undefined;
}

type BitSet = BitDetail[];

export const strawberry: Palette = {
    optionID: 0,
    // back1: 0xf30606, //OLD STRAWBERRY
    // back2: 0x440000,
    // back3: 0x000000,
    // text1: 0xff9999,
    // text2: 0xddaaaa
    back1: 0xf30629,
    back2: 0x440000,
    // useAlt: false,
    // alt1: 0xaaaaaa,
    // alt2: 0xaaaaaa,
    text1: 0xff584b, //dark
    text2: 0xd8ff63,//light
    bits: [
        {
            sprite: 'seed',
            weight: 1,
            colourMode: 1
        },
        {
            sprite: 'seed',
            weight: 0.8,
            colourMode: 2
        },
        {
            sprite: 'strawberrychunk1',
            weight: 0.05,
            colourMode: 2,
            scale: 0.35,
            realbit: true
        },
        {
            sprite: 'strawberrychunk2',
            weight: 0.05,
            colourMode: 2,
            scale: 0.35,
            realbit: true
        },
        {
            sprite: 'strawberry1',
            weight: 0.01,
            colourMode: 2,
            scale: 0.2,
            variableScale: 0.1,
            realbit: true
        },
        {
            sprite: 'strawberryLightSeeds1',
            weight: 0.01,
            colourMode: 2,
            scale: 0.2,
            variableScale: 0.1,
            realbit: true
        },
        {
            sprite: 'strawberryRare',
            weight: 0.0001,
            colourMode: 2,
            scale: 0.17,
            variableScale: 0.03,
            realbit: true
        },
        {
            sprite: 'strawberry2',
            weight: 0.02,
            colourMode: 2,
            scale: 0.23,
            variableScale: 0.03,
            realbit: true
        },
        {
            sprite: 'strawberry3',
            weight: 0.008,
            colourMode: 2,
            scale: 0.23,
            variableScale: 0.07,
            realbit: true
        },
        {
            sprite: 'strawberry4',
            weight: 0.02,
            colourMode: 2,
            scale: 0.20,
            variableScale: 0.07,
            realbit: true
        },
    ]
}

const blueberry: Palette = {
    optionID: 1,
    back1: 0x7426f0,
    back2: 0x000044,
    // useAlt: false,
    // alt1: 0xaaaaaa,
    // alt2: 0xaaaaaa,
    text1: 0x8575ff,
    text2: 0xc484ff,
    bits: [
        {
            sprite: 'seed',
            weight: 1.2,
            scale: 0.18,
            colourMode: 1
        },
        // {
        //     sprite: 'seed',
        //     weight: 0.5,
        //     colourMode: 2
        // },
        {
            sprite: 'blueberry1',
            weight: 0.3,
            colourMode: 2,
            scale: 0.43,
            variableScale: 0.4,
            realbit: true
        },
        {
            sprite: 'blueberry2',
            weight: 0.1,
            colourMode: 2,
            scale: 0.2,
            variableScale: 0.35,
            realbit: true
        },
        {
            sprite: 'blueberry3',
            weight: 0.1,
            colourMode: 2,
            scale: 0.2,
            variableScale: 0.3,
            realbit: true
        },
    //    {
    //         sprite: undefined,
    //         rotationSheet: 'earth',
    //         weight: 0.1,
    //         scale: 0.3,
    //         colourMode: 0,
    //         realbit: true
    //     },
    //     {
    //         sprite: undefined,
    //         rotationSheet: 'clouds',
    //         weight: 0.02,
    //         scale: 0.3,
    //         colourMode: 0,
    //         realbit: true
    //     },
    ]
}

const raspberry: Palette = {
    optionID: 2,
    back1: 0xf3064b,
    back2: 0x400019,
    // useAlt: false,
    // alt1: 0xaaaaaa,
    // alt2: 0xaaaaaa,
    text1: 0xf7274e,
    text2: 0xf94886,
    bits: [
        {
            sprite: 'raspseed',
            weight: 3,
            scale: 0.32,
            colourMode: 2
        },
        // {
        //     sprite: 'seed',
        //     weight: 1,
        //     colourMode: 2
        // },
        // {
        //     sprite: 'raspberryseg',
        //     weight: 1,
        //     scale: 0.3,
        //     variableScale: 0.05,
        //     colourMode: 2
        // },
        {
            sprite: 'raspberryseg2',
            weight: 0.5,
            scale: 0.32,
            variableScale: 0.05,
            colourMode: 2
        },
        // {
        //     sprite: 'raspberryseg3',
        //     weight: 0.1,
        //     scale: 0.32,
        //     variableScale: 0.05,
        //     colourMode: 2
        // },
        {
            sprite: undefined,
            rotationSheet: 'raspchunk',
            weight: 0.3,
            scale: 0.32,
            colourMode: 2,
            realbit: true
        },
        {
            sprite: undefined,
            rotationSheet: 'raspchunk2',
            weight: 0.3,
            scale: 0.32,
            colourMode: 2,
            realbit: true
        },
        {
            sprite: 'raspchunk3',
            weight: 0.3,
            scale: 0.32,
            colourMode: 2
        },
        {
            sprite: undefined,
            rotationSheet: 'raspchunk4',
            weight: 0.15,
            scale: 0.38,
            colourMode: 2,
            realbit: true
        },
        {
            sprite: 'raspberryContrast',
            weight: 0.3,
            scale: 0.66,
            realbit: true,
            variableScale: 0.2,
            colourMode: 2
        },
    ]
}

const blackberry: Palette = {
    optionID: 8,
    back1: 0x7200ad,
    back2: 0x0f0019,
    // useAlt: false,
    // alt1: 0xaaaaaa,
    // alt2: 0xaaaaaa,
    text1: 0xa127f7,
    text2: 0x7931ac,
    bits: raspberry.bits
}

const summerfruits: Palette = {
    optionID: 9,
    back1: 0xfe0036,
    back2: 0x190025,
    // useAlt: true,
    // alt1: 0xf60023,
    // alt2: 0x5e001b,
    text1: 0xb20b62,
    text2: 0xf81e42,
    bits: [
        {
            sprite: 'seed',
            weight: 2,
            colourMode: 1
        },
        {
            sprite: 'seed',
            weight: 2,
            colourMode: 2
        },
        {
            sprite: 'blueberry1',
            weight: 1,
            colourMode: 1,
            scale: 0.33,
            variableScale: 0.4,
            realbit: true
        },
        {
            sprite: 'blueberry1',
            weight: 1,
            colourMode: 2,
            scale: 0.43,
            variableScale: 0.4,
            realbit: true
        },
        {
            sprite: 'raspberryContrast',
            weight: 0.1,
            scale: 0.63,
            realbit: true,
            variableScale: 0.2,
            colourMode: 1
        },
        {
            sprite: 'blackberry',
            weight: 0.1,
            scale: 0.66,
            realbit: true,
            variableScale: 0.2,
            colourMode: 2
        },
    ]
}

const marmalade: Palette = {
    optionID: 3,
    back1: 0xff8400,
    back2: 0xa61700,
    // useAlt: false,
    // alt1: 0xaaaaaa,
    // alt2: 0xaaaaaa,
    text1: 0xda5c00,
    text2: 0xfa9a0a,
    bits: [
        // {
        //     sprite: 'shred1',
        //     weight: 2,
        //     colourMode: 2
        // },
        {
            sprite: undefined,
            weight: 2,
            colourMode: 0
        },
        {
            sprite: 'juicepod',
            weight: 4,
            scale: 0.18,
            colourMode: 1
        },
        {
            sprite: 'juicepod2',
            weight: 2,
            scale: 0.18,
            colourMode: 1
        },
        {
            sprite: 'juicepod3',
            weight: 1,
            scale: 0.18,
            colourMode: 1
        },
        {
            sprite: 'juicepod4',
            weight: 1,
            scale: 0.18,
            variableScale: 0.04,
            colourMode: 1
        },
        {
            sprite: 'juicepod5',
            weight: 0.3,
            scale: 0.18,
            colourMode: 1
        },
        {
            sprite: 'orangebase',
            // rotationSheet: 'orangepulp',
            weight: 0.07,
            scale: 0.18,
            variableScale: 0.05,
            colourMode: 1,
            realbit: true
        },
        {
            sprite: 'shred',
            weight: 3,
            colourMode: 2
        },
        {
            sprite: 'shred3',
            weight: 0.3,
            colourMode: 2
        },
        {
            sprite: 'shred4',
            weight: 0.3,
            colourMode: 2
        },
        {
            sprite: 'curl',
            weight: 0.1,
            colourMode: 2,
            scale: 0.2
        },
        {
            sprite: 'curl1',
            weight: 0.02,
            colourMode: 2,
            scale: 0.35
        },
        {
            sprite: 'pip',
            weight: 0.02,
            colourMode: 1,
            scale: 0.3
        },
        {
            sprite: 'wedge',
            weight: 0.1,
            colourMode: 2,
            scale: 0.37,
            variableScale: 0.08,
            realbit: true
        },
    ]
}

const lemoncurd: Palette = {
    optionID: 4,
    back1: 0xedc14a,
    back2: 0xb47700,
    // useAlt: false,
    // alt1: 0xaaaaaa,
    // alt2: 0xaaaaaa,
    text1: 0xd5a329,
    text2: 0xffcf5d,
    bits:
    [
        {
            sprite: undefined,
            weight: 10,
            colourMode: 0
        },
        ...marmalade.bits
    ]
        
}

const limejelly: Palette = {
    optionID: 6,
    back1: 0x54f000,
    back2: 0x005504,
    // useAlt: false,
    // alt1: 0xaaaaaa,
    // alt2: 0xaaaaaa,
    text1: 0x0ca233,
    text2: 0x5dff78,
    bits: 
        marmalade.bits
}

const bloodorange: Palette = {
    optionID: 7,
    back1: 0xfa2711,
    back2: 0x500015,
    // useAlt: false,
    // alt1: 0xaaaaaa,
    // alt2: 0xaaaaaa,
    text1: 0xd62b0e,
    text2: 0xfa7411,
    bits: 
        marmalade.bits
}

const rotten: Palette = {
    optionID: -1,
    back1: 0x738a23,
    back2: 0x19110a,
    // useAlt: false,
    // alt1: 0xaaaaaa,
    // alt2: 0xaaaaaa,
    text1: 0x738a23,
    text2: 0x2e2011,
    bits: [
        {
            sprite: 'fly2',
            weight: 1,
            colourMode: 2
        },

        {
            sprite: 'fly2',
            weight: 1,
            colourMode: 2
        }
    ]
}

const mango: Palette = {
    optionID: 5,
    back1: 0xf3bc15,
    back2: 0x972e00,
    // useAlt: false,
    // alt1: 0xaaaaaa,
    // alt2: 0xaaaaaa,
    text1: 0xff7232,
    text2: 0xf5ff53,
    bits: [
        // {
        //     sprite: 'squarechunk',
        //     weight: 0.3,
        //     colourMode: 1,
        //     scale: 0.3
        // },
        
        // {
        //     sprite: undefined,
        //     rotationSheet: 'roundedchunk',
        //     weight: 0.5,
        //     scale: 0.5,
        //     colourMode: 1
        // },
        {
            sprite: undefined,
            weight: 1,
            colourMode: 0
        },
        {
            sprite: 'blackonion',
            weight: 3,
            scale: 0.25,
            colourMode: 2
        },
        {
            sprite: 'chilliseed',
            weight: 2,
            scale: 0.25,
            colourMode: 1
        },
        {
            sprite: 'chilli',
            weight: 0.05,
            scale: 0.25,
            realbit: true,
            colourMode: 0
        },
        {
            sprite: 'chilli2',
            weight: 0.05,
            scale: 0.25,
            realbit: true,
            colourMode: 0
        },
        {
            sprite: 'chilli3',
            weight: 0.1,
            colourMode: 0
        },
        {
            sprite: 'chilli4',
            weight: 0.1,
            colourMode: 0
        },
        // {
        //     sprite: 'onion',
        //     weight: 0.05,
        //     scale: 0.15,
        //     realbit: true,
        //     colourMode: 0
        // },
        // {
        //     sprite: undefined,
        //     rotationSheet: 'cube',
        //     weight: 0.5,
        //     scale: 0.8,
        //     colourMode: 1,
        //     realbit: true
        // },
        {
            sprite: undefined,
            rotationSheet: 'trianglechunk',
            weight: 0.3,
            scale: 0.7,
            colourMode: 1,
            realbit: true
        },
        // {
        //     sprite: 'chilli2',
        //     weight: 0.01,
        //     colourMode: 0
        // },
        // {
        //     sprite: 'chilli3',
        //     weight: 0.01,
        //     colourMode: 0
        // },
    ]
}

const bakedbeans: Palette = {
    optionID: 10,
    back1: 0xff831f,
    back2: 0x871900,
    // useAlt: false,
    // alt1: 0xaaaaaa,
    // alt2: 0xaaaaaa,
    text1: 0xa2330c,
    text2: 0xff9d3d,
    bits: 
        [
            {
            sprite: undefined,
            weight: 5,
            colourMode: 0
            },
            {
            sprite: 'bean1',
            weight: 2,
            scale: 0.15,
            variableScale: 0.1,
            colourMode: 1
            },
            {
            sprite: 'bean2',
            weight: 3,
            scale: 0.15,
            variableScale: 0.1,
            colourMode: 1
            },
            {
            sprite: 'bean3',
            weight: 1,
            scale: 0.25,
            colourMode: 1
            },
            {
            sprite: 'bean4',
            weight: 2,
            scale: 0.15,
            variableScale: 0.1,
            colourMode: 1
            },
            {
            sprite: 'bean1',
            weight: 1,
            scale: 0.15,
            variableScale: 0.1,
            colourMode: 2
            },
            {
            sprite: 'bean2',
            weight: 1.5,
            scale: 0.15,
            variableScale: 0.1,
            colourMode: 2
            },
            {
            sprite: 'bean3',
            weight: 0.5,
            scale: 0.25,
            colourMode: 2
            },
            {
            sprite: 'bean4',
            weight: 1,
            scale: 0.15,
            variableScale: 0.1,
            colourMode: 2
            },
        ]
}

const palettes: Palette[] = 
    [
        strawberry,
        blueberry,
        raspberry,
        blackberry,
        summerfruits,
        marmalade,
        lemoncurd,
        limejelly,
        bloodorange,
        mango,
        bakedbeans
    ]

export let currentPalette: Palette = {...strawberry, back1: 0xffffff, }; //assign palette. don't think this is the best palce for it idk

let progress = 0.01;
let isActive = false;
let finalPalatte: Palette;

export function setPalette() {

    const chosenPalette = {...findPalette(settingValue(findSettingByID(1))?? 0) ?? strawberry};
    
    finalPalatte = {...chosenPalette,
        bits: chosenPalette.bits.map(bit => ({ ...bit })), //ensure unique selection to ensure modification does not affect future palettes
        // useAlt: chosenPalette.useAlt
    }
    // if (!finalPalatte.alt1) {
    //     finalPalatte.alt1 = finalPalatte.back1
    // }
    // if (!finalPalatte.alt2) {
    //     finalPalatte.alt1 = finalPalatte.back2
    // }
    if (settingValue(findSettingByID(35)) === 0) {
        console.log("Turning off real fruit pieces")
            finalPalatte.bits = finalPalatte.bits.filter(bit => {
                if (bit.realbit && bit.realbit === true) {
                    return false;
                } else return true;
            })
           
    } else {
        console.log("Turning ON real fruit pieces")
    }

    // finalPalatte.bits.forEach(bit => {
    //     if (bit.scale && bit.variableScale) {
    //         bit.scale = bit.scale + Math.random()*bit.variableScale;
    //     }
    // })

    const colourKeys = (Object.keys(currentPalette) as Array<keyof typeof currentPalette>)
    .filter(key => typeof currentPalette[key] === 'number' && key !== 'optionID') as Array<keyof typeof currentPalette>; 

    const hygiene = settingValue(findSettingByID(37))
    if (hygiene !== undefined && hygiene < 100) {
        const flyWeight = 0.05*(100-hygiene);
        finalPalatte.bits.push(
            {
                sprite: 'fly',
                weight: flyWeight,
                colourMode: 2
            }
        )
        finalPalatte.bits.push(
            {
                sprite: 'fly2',
                weight: flyWeight/2,
                colourMode: 2
            }
        )
        if (hygiene <= 50) {
            // (Object.keys(finalPalatte) as Array<keyof typeof finalPalatte>).forEach( key => {
            //     if (Array.isArray(finalPalatte[key])) {
            //         return; //don't change bitsets, can't interpolate obviously
            //     }
            //     (finalPalatte[key] as number) = interpColour(finalPalatte[key], rotten[key] as number, Math.max(0, Math.min(1, 1-(hygiene/50))))
            // })

            colourKeys.forEach(key => {
                (finalPalatte[key] as number) = interpColour(finalPalatte[key] as number, rotten[key] as number, Math.max(0, Math.min(1, 1-(hygiene/50))))
            })

        }
    }

    currentPalette.bits = finalPalatte.bits.map(bit => ({ ...bit }));
    background.updateBits();

    if (isActive) {
        progress =  Math.max(0.01, progress-1)
        return;
    }

    isActive = true;
    progress = 0.01;
    
    menu?.updateColour(true) //start updates for menu 
    updateHTMLColour(true);
    
    for (const instance of viewportInstances) {
                instance.updateTextColour(true)
    }

    let paletteTickLast = 0;

    const tick = () => {
        if (paletteTickLast++ < 2) return;
        paletteTickLast = 0;
        // (Object.keys(currentPalette) as Array<keyof typeof currentPalette>).forEach( key => {
        //     if (Array.isArray(currentPalette[key])) {
        //         return; //don't change bitsets, can't interpolate obviously
        //     }
        //     (currentPalette[key] as number) = interpColour(currentPalette[key], finalPalatte[key] as number, progress) //bypass typescript checks
        // })

        colourKeys.forEach(key => {
            (currentPalette[key] as number) = interpColour(currentPalette[key] as number, finalPalatte[key] as number, progress);
        });

        progress += 0.2/(1+(progress));
        
        colouriseFilter.colour = interpColour(currentPalette.back1, currentPalette.text1, 0.5)
            colouriseFilter.lightColour = currentPalette.back1,
            colouriseFilter.darkColour = currentPalette.back2

        if (progress >= 1) {
            currentPalette = {
                ...finalPalatte,
                bits: finalPalatte.bits.map(bit => ({ ...bit }))
            };
            menu.updateColour(false) //end updates
            updateHTMLColour(false);
            for (const instance of viewportInstances) {
                instance.updateTextColour(false)
            }
            
            // for (const child of mainContainer.children) {
            //     if (child instanceof ViewportInstance) {
            //         child.updateTextColour(false);
            //     }
            // }
            isActive = false;
            app.ticker.remove(tick)
        }
    }

    app.ticker.add(tick);
}

export function findPalette(id: number): Palette | undefined {
    const foundPalette = palettes.find(palette => palette.optionID === id);
    console.log(typeof id, id);
    console.log(palettes.map(p => p.optionID));
    if (foundPalette === undefined) {
        console.error(`Palette with ID ${id} Not found`);
        return undefined;
    } else {
        return foundPalette;
    }
}